import http from '../../../../../libs/http'
import Cookies from 'js-cookie'
const token = JSON.parse(Cookies.get('user')).token
export default (path) => http.getUri({ url: `${process.env.VUE_APP_MICROSERVICE_API_PUBLICACIONES}/files${path}`, params: { token } })
